/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */
import { isArray } from './isArray';
export function isNumeric(val) {
    return !isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
//# sourceMappingURL=isNumeric.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isNumeric.js
// module id = 238
// module chunks = 2